
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">上架店家 - {{portal.title}}</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->

                <div class="row">
                  <div class="col-md-12">
                    <el-row :gutter="20">
                      <el-col :xs="12" :md="3">
                        <router-link to="../../portals" type="success">
                          <el-button type="warning" size="small">返回入口列表</el-button>
                        </router-link>
                      </el-col>
                    </el-row>
                    <hr />
                    <h5>入口總覽</h5>
                    <ul>
                      <li>
                        <strong>目前上架店家數：{{data.length}}</strong>
                      </li>
                      <li>
                        <strong>目前透過此入口下單數量（包含曾加入但已被移除店家）：{{portal.orderCount || 0}}</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-header">
                <h5>上架店家列表</h5>
              </div>
              <div class="card-body">
                <el-row :gutter="20">
                  <el-col :xs="24" :md="6">
                    <el-input
                      v-model="filters[0].value"
                      size="small"
                      placeholder="搜尋店家"
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </el-col>
                  <!-- <el-col :xs="24" :md="6">
                        <el-button
                          type="danger"
                          @click.native="openAddShopPage()"
                          size="small"
                          plain
                        >新增參與店家</el-button>
                  </el-col>-->
                  <el-col :xs="24" :md="6">
                    <router-link to="./add-shops" >
                      <el-button type="info" style="background-color: #0ABBF9;border-color: #0ABBF9;" size="small"><i class="el-icon-s-shop"></i>新增參與店家</el-button>
                    </router-link>
                    <!-- <router-link to="./add-shops" type="success">
                      <el-button type="danger" size="small" plain>批次匯入優惠券</el-button>
                    </router-link> -->
                  </el-col>
                </el-row>
                <data-tables :data="data" :filters="filters" :action-col="actionCol">
                  <!--<el-table-column label="選擇" prop="id" sortable="custom">
                    <template slot-scope="scope">
                      <div class="checkbox-radios">
                        <checkbox v-model="scope.row.selected" class="pull-left" name="subscribe"></checkbox>
                      </div>
                    </template>
                  </el-table-column>-->
                  <!--<el-table-column label="狀態" prop="id" sortable="custom">
                    <template slot-scope="scope">
                      <span>
                      <n-switch style="margin:3px 0 0 0;" v-model="scope.row.enabled" @click.native="switchCampaign(scope.row.id, scope.$index)" color="green">
                      <i class="fa fa-check" slot="on"></i>
                      <i class="fa fa-exclamation" style="color:red;" slot="off"></i>
                      </n-switch>
                      </span>
                     
                      <span> {{scope.row.statusDisplay}}</span>
                    </template>
                  </el-table-column>-->
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from "element-ui";
import {
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    Checkbox,
    Radio,
    [Switch.name]: Switch,
    FgInput
  },
  data() {
    return {
      updateInfo: null,
      updateConditions: null,
      updateMessages: null,
      dlError: null,
      sentQty: 0,
      voucherQty: 0,
      portal: {
      },
      startTime: "",
      endTime: "",
      data: [],
      titles: [
        {
          prop: "id",
          label: "商店ID"
        },
        // {
        //   prop: "shopId",
        //   label: "商店ID"
        // },
        {
          prop: "name",
          label: "店家名稱"
        },
        {
          prop: "orderCount",
          label: "訂單數量"
        },
        // {
        //   prop: "sent",
        //   label: "已發出"
        // },
        // {
        //   prop: "remain",
        //   label: "剩餘數"
        // },
        // {
        //   prop: "statusDisplay",
        //   label: "是否啟用"
        // },
        // {
        //   prop: "updatedAt",
        //   label: "加入時間"
        // }
      ],
      actionCol: {
        label: "操作",
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              type: "danger",
              size: "mini",
              icon: "el-icon-delete-solid"
            },
            label: "移除此商店",
            handler: row => {
              console.log("the row is ", row);
              this.deleteShop(row.id);
              // this.$router.push(`/portals/${this.$route.params.portalKey}/vouchers/${row.id}`);
            }
          }
        ]
      },
      filters: [
        {
          value: "",
          prop: ["name", "id"]
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    windowClosing() {
      // this.getSpecialOpenings();
      this.getPortalShops();
    },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    deleteShop(shopId) {
      let self = this;
      console.log('send delete ' + shopId);
      return axios
        .delete(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}/shops/${shopId}`
        )
        .then(response => {
          return self.getPortalShops();
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    },
    getPortalDetail() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}`
        )
        .then(response => {
          console.log('the response ' + JSON.stringify(response.data));
          this.portal = response.data || {};
          if (response.data.banners)
            this.banners = response.data.banners;
          
          // this.formatCampaign();
          
          return response.data;
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    },
    // getOverview() {
    //   return axios
    //     .get(
    //       `${process.env.VUE_APP_APIHOST}/si/voucher-campaigns/${this.$route.params.portalKey}/overview`
    //     )
    //     .then(response => {
    //       // this.portal = response.data || {};

    //       let totalMap = {};
    //       for (let i = 0; i < response.total.length; ++i) {
    //         totalMap[response.total[i].campaignId] = response.total[i].codeCount;
    //       }

    //       let sentMap = {};
    //       for (let i = 0; i < response.sent.length; ++i) {
    //         sentMap[response.sent[i].campaignId] = response.sent[i].sentCount;
    //       }

    //       return response.data;
    //     });
    // },
    getPortalShops() {
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}/shops`
        )
        .then(response => {
          this.data = response.data;
          this.voucherQty = 0;
          this.sentQty = 0;
          for (let a of this.data) {
            a.updatedAt = moment
              .unix(a.updatedTs)
              .format("YYYY-MM-DD HH:mm:ss Z");

            a.enabled = (a.status === 'enabled' ? true : false);
            a.statusDisplay = a.status === "disabled" ? '暫停中' : '運作中';
            // a.statusType = a.status === "disabled" ? 'danger': 'success';
            // a.statusIcon = a.status === "disabled" ? 'el-icon-close': 'el-icon-open';
            
            a.remain = a.total - a.sent;
            this.voucherQty += a.total;
            this.sentQty += a.sent;
          }
          return response.data;
        });
    }
  },
  mounted() {
    this.getPortalDetail();
    this.getPortalShops();
    // this.getOverview();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.k-form-label {
  margin: 5px 0 0 0;
}
.k-form-group {
  margin: 10px 0 10px 0;
}
/* .k-input input { */
/* margin: 10px; */
/* width: 100px; */
/* height: 30px; */
/* } */
</style>